import {
    CYBERSOURCE_INIT_SUCCEEDED,
    CYBERSOURCE_CARDINAL_INIT_SUCCEEDED,
    CYBERSOURCE_SET_SUBMITTING
} from '../actions/constants/action-types';

const INITIAL_STATE = {
    message: '',
    isSubmitting: false,
    data: {
        cancellationUrl: '',
        captureContext: '',
        cardinalToken: '',
        cardinalSessionId: ''
    }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CYBERSOURCE_INIT_SUCCEEDED: {
            const {payload: data} = action;
            return {
                ...state,
                data,
                error: false
            };
        }
        case CYBERSOURCE_CARDINAL_INIT_SUCCEEDED: {
            const {payload: cardinalSessionId} = action;
            return {
                ...state,
                data: {
                    ...state.data,
                    cardinalSessionId
                }
            };
        }
        case CYBERSOURCE_SET_SUBMITTING: {
            const {payload: isSubmitting} = action;
            return {
                ...state,
                isSubmitting
            };
        }
        default: {
            return state;
        }
    }
};
